module.exports = __webpack_public_path__ + "img/img_body_biz_hyundai_capital_logo.439efd11.png";